import CryptoJS from 'crypto-js';
import crypto from 'crypto';

export function encryptAES(plainText, password, config = { keySize: 256, iterations: 1 }) {
  const { keySize } = config;
  const { iterations } = config;
  const salt = CryptoJS.lib.WordArray.random(128 / 8);

  const key = CryptoJS.PBKDF2(password, salt, {
    keySize: keySize / 32,
    hasher: CryptoJS.algo.SHA512,
    iterations: iterations,
  });

  const iv = CryptoJS.lib.WordArray.random(128 / 8);

  const encrypted = CryptoJS.AES.encrypt(plainText, key, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });

  const encryptedMessage = encrypted.toString() + iv.toString() + salt.toString();
  return encryptedMessage;
}

export function decryptAES(encryptedMessage, password, config = { keySize: 256, iterations: 1 }) {
  const { keySize } = config;
  const { iterations } = config;

  const salt = CryptoJS.enc.Hex.parse(encryptedMessage.substr(encryptedMessage.length - 32));
  const iv = CryptoJS.enc.Hex.parse(encryptedMessage.substr(encryptedMessage.length - 64, 32));
  const encrypted = encryptedMessage.substr(0, encryptedMessage.length - 64);

  const key = CryptoJS.PBKDF2(password, salt, {
    keySize: keySize / 32,
    hasher: CryptoJS.algo.SHA512,
    iterations: iterations,
  });

  const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });

  const decryptedMessage = decrypted.toString(CryptoJS.enc.Utf8);
  if (!decryptedMessage) {
    throw new Error('Decrypt Error');
  }

  return decryptedMessage;
}

export function encrypt_AES256_2(text, masterkey) {
  const iv = crypto.randomBytes(16);
  const cipher = crypto.createCipheriv('aes-256-gcm', masterkey, iv);
  const encrypted = Buffer.concat([
    cipher.update(text, 'utf8'),
    cipher.final(),
  ]);
  const tag = cipher.getAuthTag();
  return Buffer.concat([iv, encrypted, tag]).toString('base64');
}

export function decrypt_AES256_2(encdata, masterkey) {
  const bData = Buffer.from(encdata, 'base64');
  const iv = bData.slice(0, 16);
  const tag = bData.slice(bData.length - 16, bData.length);
  const text = bData.slice(16, bData.length - 16);
  const decipher = crypto.createDecipheriv('aes-256-gcm', masterkey, iv);
  decipher.setAuthTag(tag);
  const decrypted =
    decipher.update(text, 'binary', 'utf8') + decipher.final('utf8');
  return decrypted;
}